<template>
	<div class="cont_box">
		<div class="gall_box bai_box">
			<div class="gall_mbx">
				<el-breadcrumb separator=">">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<!-- <el-breadcrumb-item>图库</el-breadcrumb-item> -->
					<el-breadcrumb-item>{{codeName.name}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="gall_slt" @click="slt_btn">
				<img src="../../assets/image/icon_tk_kssx@2x.png" alt="" class="icon">
				<span>快速筛选</span>
			</div>
			<div class="gall_cont">
				<div class="gall_cont_top">
					<div class="gall_cont_txz">
						<div class="galls" @click="m_flag=!m_flag">
							<div class="gall_cont_name">
								{{m_name}}
							</div>
							<div class="gall_cont_icon" :class="{'xz_class': m_flag}">
								<img src="../../assets/image/icon_kssx_xl@2x.png" alt="" class="img">
							</div>
						</div>
						
						<div class="gall_xdata" v-show="m_flag">
							<!-- <div class="gall_xdata_title">
								{{1 | qxzname}}
							</div> -->
							<div class="gall_xdata_list">
								<div class="gall_xdata_item" @click="m_btn(item)" v-for="(item,index) in mData" :key="index" :class="{'active': m_name == item.name}">
									{{item.name}}
								</div>
							</div>
						</div>
						<div class="gall_hei" @click="m_flag=false" v-show="m_flag"></div>
					</div>
					<div class="gall_cont_txz">
						<div class="galls" @click="k_flag=!k_flag">
							<div class="gall_cont_name">
								{{k_name}}
							</div>
							<div class="gall_cont_icon" :class="{'xz_class': k_flag}">
								<img src="../../assets/image/icon_kssx_xl@2x.png" alt="" class="img">
							</div>
						</div>
						<div class="gall_xdata" v-show="k_flag">
							<!-- <div class="gall_xdata_title">
								{{2 | qxzname}}
							</div> -->
							<div class="gall_xdata_list">
								<div class="gall_xdata_item" @click="k_btn(item)" v-for="(item,index) in kData" :key="index" :class="{'active': k_name == item.name}" v-if="kData.length">
									{{item.name}}
								</div>
								<div v-if="!kData.length" style="padding-bottom: 15px;color: #232323;font-size: 12px;">
									暂无数据
								</div>
							</div>
						</div>
						<div class="gall_hei" @click="k_flag=false" v-show="k_flag"></div>
					</div>
					<div class="gall_cont_btn" @click="gal_btn">
						筛选
					</div>
				</div>
			</div>
			<div class="gall_list">
				<div class="gall_item" v-for="(item,index) in gData.records" :key="index">
					<img  oncontextmenu="return false;" ondragstart="return false;" :src="item.urls.url" @click="gall_btn(item)" alt="" class="img">
				</div>
			</div>
			<div class="gall_fy">
				<div class="block">
					<el-pagination :page-sizes="[10, 20, 50, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="gData.current"
					 :page-size="gData.size" layout="total, sizes, prev, pager, next, jumper" :total="gData.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';
	let vm
	export default {
		name: "UserDialong",
		data() {
			vm = this
			return {
				not_flag: true,
				tab_index: 'tk',
				currentPage3: 5,
				k_flag: false,
				m_flag: false,
				mData: '', // 目信息
				kData: '', // 科信息
				m_name: '选择作物类型', // 当前选中的目
				k_name: '选择作物名', // 当前选中的科
				params: {
					categoryCode: '',
					categoryId: '',
					page: 1,
					size: 10,
				}, // 虫类参数
				gData: {
					current: 1,
					size: 1,
					pages: 1,
				},
				ks_id: '', // 科id
				m_id: '', // 目id
			}
		},
		computed: {
			codeName() {
				let name = ''
				for (let item of this.fldata) {
					if (item.code == this.gallyIndex) {
						name = item
					}
				}
				return name
			},
			gallyIndex() {
				return this.$store.state.gallyIndex
			},
			fldata() {
				return this.$store.state.fldata
			}
		},
		filters:{
			qxzname(val) {
				let name = ''
				for (let item of vm.$store.state.fldata) {
					if (item.code == vm.gallyIndex) {
						name = item.name
					}
				}
				if(val==1){
					return name=='农业病害'?'作物类型':'目'
				}else{
					return name=='农业病害'?'作物名':'科'
				}
			}
		},
		mounted() {
			setTimeout(res => {
				let name = ''
				for (let item of vm.$store.state.fldata) {
					if (item.code == vm.gallyIndex) {
						name = item.name
					}
				}
				if(name=='农业病害'){
					this.m_name = '选择作物类型' // 当前选中的目
					this.k_name = '选择作物名' // 当前选中的科
				}else{
					this.m_name = '选择目' // 当前选中的目
					this.k_name = '选择科' // 当前选中的科
				}
			})
			this.init()
		},
		
		methods: {
			gal_btn() {
				if(this.m_name.includes('选择')){
					this.$message.warning(this.m_name);
					return
				}
				if(this.k_name.includes('选择')){
					this.k_name = ''
				}
				let ids = this.ks_id? this.ks_id:  this.m_id
				this.$router.push({path: '/gallery_decTw',query: {mName: this.m_name,kName: this.k_name,zName: this.m_name,id: ids}})
			},
			k_btn(item) {
				this.k_name = item.name
				this.ks_id = item.id
				this.k_flag = !this.k_flag
			},
			m_btn(item) {
				this.m_name = item.name
				this.m_id = item.id
				this.m_flag = !this.m_flag
				this.k_fn(item.id)
			},
			k_fn(id){
				this.$http.get('/front/gallery/child/categories', {
					parentId: id,
				}).then(res => {
					let data = res.data
					this.kData = data
				})
			},
			init() {
				setTimeout(red => {
					this.$http.get('/front/gallery/child/categories', {
						parentId: this.codeName.id,
					}).then(res => {
						let data = res.data
						this.mData = data
					})
					this.ga_fn()
				})
			},
			ga_fn() {
				setTimeout(red => {
					this.params.categoryCode = this.gallyIndex
					this.$http.get('/front/gallery/galleries', this.params).then(res => {
						let data = res.data.records
						let newData = []
						for(let item of data) {
							let {imgInfos,...datas} = item
							for(let childitem of imgInfos){
								newData.push({
									urls: {
										...childitem
									},
									...datas
								})
							}
						}
						let resData = res.data
						resData.records = newData
						this.gData = resData
					})
				})
			},
			gall_btn(item) {
				this.$router.push({path: '/gallery_describe',query: {id: item.id,cName: item.name,kName: item.categoryName}})
			},
			slt_btn() {
				this.$router.push({
					path: 'gallery_indexTw'
				})
			},
			handleSizeChange(val) {
				this.params.page = 1
				this.params.size =val
				this.ga_fn()
			},
			handleCurrentChange(val) {
				this.params.page = val
				this.ga_fn()
			}
		},
		components: {
			headers,
			foot,
		}
	}
</script>

<style lang="less" scoped>
	.gall_box {
		//width: 870px;
		width: 1200px;
		margin: 0 auto;
		padding: 0 0 30px;

		.gall_mbx {
			margin: 0 0 30px;
			padding: 37px 23px 0;

			span {
				font-size: 13px;
			}
		}

		.gall_slt {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			cursor: pointer;
			padding: 0 23px;

			.icon {
				width: 18px;
				height: 17px;
				margin-right: 16px;
			}

			span {
				font-size: 15px;
				color: #22AB67;
			}
		}
		.gall_list{
			padding: 60px 0 15px 33px;
			display: flex;
			flex-wrap: wrap;
			.gall_item{
				width: 120px;
				height: 120px;
				margin: 0 51px 30px 0;
				padding: 4px;
				border: 1px solid #ccc;
				box-sizing: border-box;
				.img{
					width: 100%;
					height: 100%;
					object-fit: contain;
					cursor: pointer;
				}
				&:nth-of-type(5n){
					margin-right: 0;
				}
			}
		}
		.gall_fy {
			margin: 30px 0 60px;

			.block {
				display: flex;
				justify-content: center;
			}
		}

		.gall_cont {
			padding: 0 23px;
			margin-top: 29px;

			.gall_cont_top {
				display: flex;

				.gall_cont_txz {
					flex: 1;
					margin-right: 23px;
					position: relative;
					.galls{
						width: 100%;
						height: 45px;
						display: flex;
						align-items: center;
						background-color: #F5F5F5;
						padding: 0 30px;
						border-radius: 8px;
						box-sizing: border-box;
						justify-content: space-between;
						cursor: pointer;
					}
					.gall_cont_name {
						font-size: 12px;
						color: #232323;
					}

					.gall_cont_icon {
						width: 17px;
						height: 11px;
						transform: translateY(-3px);
						transition: .5s;

						.img {
							width: 100%;
							height: 100%;
						}
					}
					.xz_class{
						transform: rotate(180deg);
					}
					.gall_hei{
						width: 100%;
						height: 100%;
						position: fixed;
						top: 0;
						left: 0;
						background: transparent;
						z-index: 1;
					}
					.gall_xdata {
						position: absolute;
						z-index: 10;
						overflow-y: hidden;
						top: 45px;
						background: #fff;
						width: 100%;
						left: 0;
						box-sizing: border-box;
						box-shadow: 0px 2px 5px 0px rgba(169, 186, 178, 0.35);
						padding: 20px 23px 0 30px;

						.gall_xdata_title {
							font-size: 15px;
							color: #4A4A4A;
							font-weight: bold;
							margin-bottom: 23px;
						}
						.gall_xdata_list{
							display: flex;
							flex-wrap: wrap;
							font-size: 13px;
							
							.gall_xdata_item{
								color: #4A4A4A;
								margin-right: 16px;
								margin-bottom: 23px;
								text-decoration: underline;
								cursor: pointer;
								&:hover{
									color: #22AB67;
								}
							}
							.active{
								color: #22AB67;
							}
						}
					}
				}

				.gall_cont_btn {
					width: 158px;
					height: 45px;
					background-color: #22AB67;
					line-height: 45px;
					text-align: center;
					border-radius: 8px;
					color: #fff;
					cursor: pointer;
				}
			}
		}
	}
</style>
